import { DateTime } from 'luxon';
import ICompetition from '../../../models/pa-egna-ben/competition.model.js';
import { LegApiModel } from './leg.api-model.ts.js';

export class CompetitionApiModel {
  public id!: number;
  public name!: string;
  public startTime!: string;
  public endTime!: string;
  public registrationStartTime!: string;
  public registrationEndTime!: string;
  public hideScoreboardStartTime!: string;
  public hideScoreboardEndTime!: string;
  public legs!: LegApiModel[];

  public static mapToBusinessModel(apiModel: CompetitionApiModel): ICompetition {
    return {
      id: apiModel.id,
      name: apiModel.name,
      startTime: DateTime.fromISO(apiModel.startTime),
      endTime: DateTime.fromISO(apiModel.endTime),
      registrationStartTime: DateTime.fromISO(apiModel.registrationStartTime),
      registrationEndTime: DateTime.fromISO(apiModel.registrationEndTime),
      hideScoreboardStartTime: DateTime.fromISO(apiModel.hideScoreboardStartTime),
      hideScoreboardEndTime: DateTime.fromISO(apiModel.hideScoreboardEndTime),
      legs: apiModel.legs?.map(LegApiModel.mapToBusinessModel),
    };
  }
}
